export const styles = {
  tableRow: {
    cursor: 'pointer',
  },

  button: {
    height: '3rem',
  },

  tableCell: {
    border: 'none',
  },
};
